import styled from 'styled-components'

import { colors } from '../../styles/colors'

export const BreadCrumb = styled.div`
  display: flex;
  width: 100%;
  height: 41px;
  flex-direction: row;
  align-items: center;
  padding: 14px 30px;
  justify-content: flex-start;
  background-color: ${colors.dashboard};
  margin-bottom: 15px;
  z-index: 97;
`

export const Title = styled.div`
  font-family: 'Roboto';
  font-style: italic;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.grayDark};
`

interface IContentProps {
  overflow?: string
}

export const Content = styled.div<IContentProps>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: ${props => props.overflow};
`
